import Dropdown from '../UI/Dropdown'

type FilterDropdownProps = {
  title: string
  value: string
  options: Array<{ value: string | number; name: string }>
  onChange: (value: string) => void
  className?: string
}

const FilterDropdown = ({
  title,
  value,
  options,
  onChange,
  className,
}: FilterDropdownProps): JSX.Element => (
  <Dropdown
    title={title}
    value={value}
    options={[{ name: 'All', value: '' }, ...options]}
    disabled={!options?.length}
    handleChange={onChange}
    variant="standard"
    size="small"
    withFullWidth
    className={className}
  />
)

export default FilterDropdown
